import { IStoreState } from 'state/rootReducer';

export const getPatientHeader = (state: IStoreState) =>
  state.records.cardPatient.patientHeader!;

export const getHasError = (state: IStoreState) =>
  state.records.cardPatient.hasError!;
